module.exports = __webpack_public_path__ + "static/media/woodwork1.5a331232.ogg";